exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crud-opts {\n  padding: 4px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.crud-opts .crud-opts-right {\n  margin-left: auto;\n}\n.crud-opts .crud-opts-right span {\n  float: left;\n}\n", ""]);

// exports
